import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { VozIA, GenerateVoiceIAResponse, GenerateVoiceIARequest } from 'src/app/models/voz-ia';


@Injectable({
  providedIn: 'root'
})
export class VozIaService {

  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private http: HttpClient) { }

  listarVocesIA(): Observable<VozIA[]> {
    return this.http
      .get<{ code: string; data: VozIA[] }>(
        `${this.baseUrl}/request?event=voz-ia-listar-voces`
      )
      .pipe(
        map(response => response.data)
      );
  }

  GenerateVoiceIA(
    payload: GenerateVoiceIARequest
  ): Observable<GenerateVoiceIAResponse['data']> {
    return this.http
      .post<GenerateVoiceIAResponse>(
        `${this.baseUrl}/request?event=voz-ia-generar-audio`,
        payload
      )
      .pipe(
        map(response => response.data)
      );
  }

}
